import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AlertsService } from 'src/app/demo/service/alerts.service';
import { AuthService } from 'src/app/demo/service/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { CrudService } from '../../service/crud.service';
import { StorageService } from 'src/app/utils/storage.service';
import { filter, lastValueFrom, Subscription } from 'rxjs';

@Component({
	selector: 'app-navbar-page',
	templateUrl: './navbar-page.component.html',
	styleUrl: './navbar-page.component.scss'
})
export class NavbarPageComponent implements OnInit, AfterViewInit {

	anioVigencia: number = 0;
	user: { nombres: string, apellidos: string, email: string, username: string } | null = null;
	rejectedCount: number = 0;
	private routerSub!: Subscription;

	constructor(
		private crudService: CrudService,
		private alertService: AlertsService,
		private authService: AuthService,
		private router: Router,
		private storage: StorageService,
	) { }

	async ngOnInit() {
		if (this.showButtonLogout) {
			this.getDataFromHttpOrCacheProfile();
			this.getRejectedRequests();

			this.routerSub = this.router.events
				.pipe(filter((event) => event instanceof NavigationEnd))
				.subscribe((event: NavigationEnd) => {
					this.getRejectedRequests()
				});
		}
	}

	/**
   * @author Ministerio de Cultura
   * @createdate 2025-08-11
   * @description
   * Obtiene del token los roles asignados al usuario autenticado y verifica si posee
   * el rol `reg_aprobador`, el cual habilita los botones de creación, edición
   * y envío a revisión.
   */
	// getPermissionsBoss(): boolean {
	// 	const normalizedRoles = this.authService.decodeTokenUser()['roles']
	// 	return normalizedRoles.some(rol => rol.key_publico === 'reg_aprobador');
	// }

	async ngAfterViewInit() {
		if (this.showButtonLogout) {
			let $storage = this.storage.get<any>('vigencia/all', 'local');
			let list = $storage ?? await this.queryGetList('vigencia/all', { state: 1 }, null);
			if ($storage === undefined || $storage === null) this.storage.set('vigencia/all', list, 'local');
			this.anioVigencia = list.find(ano => ano.id === this.authService.decodeTokenUser()['vigencia']).ano;
		}
	}

	ngOnDestroy(): void {
		if (this.routerSub) {
			this.routerSub.unsubscribe();
		}
	}

	async getRejectedRequests() {
		let list = await this.queryGetList(`solicitudes/mis_solicitudes`, { 'estado': 3, 'state': 2 }, null);
		this.rejectedCount = list.length;
	}

	goToRejectedRequests() {
		this.router.navigate(['sigp/modulos/mensajeria/solicitudes-rechazadas']);
	}

	/**
		* @author Ministerio de cultura
		* Método para obtener datos del perfil desde el localStorage o realizar una consulta HTTP si no están en caché.
		* @createdate 2025-03-27
	*/
	getDataFromHttpOrCacheProfile(): void {
		const starageKey: string = 'usuario';
		const storageType = 'local';
		const $storage = this.storage.get<any>(starageKey, storageType);
		if ($storage) {
			this.processProfileData($storage);
		} else {
			this.crudService.getDataWithoutPagination({ url: 'perfil/show' }).subscribe({
				next: (res) => {
					this.storage.set(starageKey, res, storageType);
					this.processProfileData(res);
				},
				error: (err) => console.error(`Error al obtener '${starageKey}' desde el servicio:`, err),
			});
		}
	}

	/**
	 * @author Ministerio de cultura
	 * Procesa y ajusta los datos del perfil o usuario.
	 * @createdate 2025-03-27
	 * @param res - Datos del perfil obtenidos del servicio o del localStorage.
	 */
	processProfileData(res: any) {
		this.user = res;
	}

	/**
	  * @author Ministerio de cultura
	  * @createdate 2025-02-28
	  * Metodo que retorna el nombre completo del usuario logeado.  
	*/
	get nombreUsuario(): string {
		return this.user ? `${this.user.nombres || ''} ${this.user.apellidos || ''}`.trim() : '';
	}

	/**
	  * @author Ministerio de cultura
	  * @createdate 2024-10-27
	  * Metodo que cierra la sesion en el sistema.
	*/
	onClickLogoutMenu(): void {
		this.alertService
			.showConfirmAlert({
				html: '¿Desea cerrar sesión en el sistema?'
			}).then(confirm => {
				if (confirm.isConfirmed) {
					this.authService.logout().subscribe(() => {
						this.authService.clearTokenWatcher();
						this.storage.clear('local');
						this.storage.clear('session');
						this.router.navigate(['/']).then(() => {
							window.location.reload();
						});
					});
				}
			})
	}

	/**
	  * @author Ministerio de cultura
	  * @createdate 2024-10-28
	  * Metodo que valida si el token en el storage existe o no.
	*/
	get showButtonLogout(): boolean {
		const starageKey: string = 'token';
		const storageType = 'local';
		return this.storage.get(starageKey, storageType) ? true : false
	}

	/**
	  * @author Ministerio de cultura
	  * @createdate 2024-11-10
	  * Metodo que redirecciona a la pagina de perfil del usuario.
	*/
	redirectToProfile(): void {
		this.router.navigate(['/sigp/modulos/perfil/mi-perfil']);
	}

	async queryGetList(endpointName: string, filter: any | null, pagination: any | null): Promise<any> {
		try {
			const res: any = await lastValueFrom(
				this.crudService.getData({ url: endpointName, filterForm: filter, pagination })
			);
			return res.data ?? [];
		} catch (err) {
			console.error('❌ Error al consultar:', err);
			throw err;
		}
	}

}